export default "__VITE_ASSET__99dd1b68__"